export const enum RolesEnum {
	ASSURE = 'assure',
	EMPLOYEUR = 'employeur',
	EMPLOYEUR_PARTICULIER = 'employeur-particulier',
	TEMOIN = 'temoin'
}
